import { v4 as uuid } from 'uuid';
import { FlowstepCategory } from 'shared/utils/flowstep';
import { toQueryString } from 'shared/utils/utils';


export const Type = {
  Pull: FlowstepCategory.Pull,
  Push: FlowstepCategory.Push,
  Custom: 'custom',
};


// TODO: move to frontend
export function getRoute({ selectedId, id = '' } = {}) {
  let url = '/home/flows';
  if (selectedId) { return url + `?${toQueryString({ selectedId })}`; }
  return url + `/flow/${id}`;
}

export function toRoute({ flow, ...rest }) {
  const { id } = flow;
  return getRoute({ id, ...rest });
}

export function generateUuid() {
  return uuid();
}

export function findFlowsteps(flows, flowsteps) {
  const notFound = new Set();
  const f = flows.flatMap(flow => 
    flow.options.flowsteps.reduce((out, x) => {
      const flowstep = flowsteps.find(y => y.id === x.id);
      flowstep ? out.push(flowstep) : notFound.add(x.id);
      return out;
    }, [])
  );

  return { flowsteps: f, notFound };
}

export function joinFlowsteps(flows, flowsteps) {
  return flows.map(flow => {
    const { flowsteps: loaded } = findFlowsteps([flow], flowsteps);
    return { ...flow, options: { ...flow.options, flowsteps: loaded }};
  });
}

export function isEmpty(flow) {
  return !flow.options.flowsteps.length;
}
